export default __webpack_public_path__ + "static/media/addevent.f843d9bb.ico";